export default "__VITE_ASSET__BW$eybNz__"